import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const Icon = ({ icon, size, title, color, style }) => {
    return (_jsx(FontAwesomeIcon, { "data-testid": "font-awesome-icon-test-id", "aria-hidden": true, title: title, icon: icon, size: size, color: color, style: style }));
};
export default Icon;
